import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { get_api_url } from '../../../utils/urls';
import * as actions from '../../../redux/action_creators';
import { post_api } from '../../../redux/api_funcs';
import Button from '../../util_components/button';
import CustomModal from '../../util_components/custom_modal';
import CustomInput from '../../util_components/custom_input';
import CustomSelect from '../../util_components/custom_single_select';

const initialForm = { name: '', email: '', password: '', access_type: '' };

export default function Sample() {
  const config_values = useSelector((state) => state.home.config_values);
  const [addUser, setAddUser] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const access_type_options = (config_values?.access_types || []).map((opt) => {
    if (typeof opt === 'string') return { value: opt, label: opt };
    return { value: opt.value, label: opt.label || opt.value };
  });

  const toggleUser = () => {
    setAddUser(!addUser);
    setForm(initialForm);
  };

  const onChange = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const onSubmit = () => {
    const { name, email, password, access_type } = form;
    if (!name || !email || !password || !access_type) {
      dispatch(actions.set_notification_variable(true, 'error', 'All fields are required.'));
      return;
    }
    setSubmitting(true);
    const url = get_api_url('add_cms_user');
    const payload = { name, email, access_type, password };
    post_api(url, payload, true)
      .then(() => {
        dispatch(actions.set_notification_variable(true, 'success', 'User added successfully.'));
        setSubmitting(false);
        setAddUser(false);
        setForm(initialForm);
      })
      .catch((e) => {
        let err_message;
        try {
          err_message = e.response.data.message;
        } catch (err) {
          err_message = 'Some error occured. Please contact dev team.';
        }
        dispatch(actions.set_notification_variable(true, 'error', err_message));
        setSubmitting(false);
      });
  };

  const renderAddUser = () => (
    <div style={{ minWidth: '320px' }}>
      <div className="text-xl font-semibold mb-4">Add User</div>
      <div className="mb-3">
        <CustomInput
          label="Name"
          name="name"
          value={form.name}
          onChange={onChange('name')}
          style={{ width: '100%' }}
        />
      </div>
      <div className="mb-3">
        <CustomInput
          label="Email"
          name="email"
          type="email"
          value={form.email}
          onChange={onChange('email')}
          style={{ width: '100%' }}
        />
      </div>
      <div className="mb-3">
        <CustomInput
          label="Password"
          name="password"
          value={form.password}
          onChange={onChange('password')}
          style={{ width: '100%' }}
        />
      </div>
      <div className="mb-4">
        <CustomSelect
          label="Access Type"
          name="access_type"
          value={form.access_type}
          options={access_type_options}
          onChange={onChange('access_type')}
          defaultOption="Select access type"
          style={{ width: '100%' }}
        />
      </div>
      <div className="flex gap-3 justify-end">
        <Button type="secondary" onClick={toggleUser} disabled={submitting}>
          Cancel
        </Button>
        <Button onClick={onSubmit} disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit'}
        </Button>
      </div>
    </div>
  );

  return (
    <>
      <CustomModal show={addUser} close={toggleUser}>
        {renderAddUser()}
      </CustomModal>
      <Button onClick={toggleUser}>Add User</Button>
    </>
  );
}
